/*
 * @Date: 2022-08-15 13:54:29
 * @LastEditTime: 2022-08-16 10:08:59
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_Export = (...params) =>
  net_common.post("/api/STDSDC01C06/Export", ...params)
